import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantCashTransferServiceSharedService } from '../../services/wealthlane-award-settlement-services';

const useGetCashTransferTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cashTransferTypes = useQuery(
    ['getCashTransferTypes'],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceSharedService.getApiAwardSettlementApiAppParticipantCashTransferServiceTransferTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return cashTransferTypes;
};

export default useGetCashTransferTypes;
